import { useState } from "react";
import { Check, Link2, Share2 } from "lucide-react";
import { toast } from "@/components/ui/sonner";

export function ShareBar({ title, text, url, testId = "event-share-bar" }) {
  const [copied, setCopied] = useState(false);
  const encodedUrl = encodeURIComponent(url);
  const encodedText = encodeURIComponent(text);
  const canNativeShare = typeof navigator !== "undefined" && Boolean(navigator.share);

  const channels = [
    { key: "x", label: "X", href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}` },
    { key: "facebook", label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}` },
    { key: "whatsapp", label: "WhatsApp", href: `https://wa.me/?text=${encodedText}%20${encodedUrl}` },
  ];

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Album link copied — post it anywhere");
      setTimeout(() => setCopied(false), 2200);
    } catch {
      toast.error("Copy failed — long-press the address bar instead");
    }
  }

  async function nativeShare() {
    try {
      await navigator.share({ title, text, url });
    } catch (error) {
      if (error?.name !== "AbortError") await copyLink();
    }
  }

  const buttonClass = "inline-flex items-center gap-1.5 border border-white/15 px-3 py-2 font-mono text-[10px] uppercase tracking-[0.16em] text-zinc-300 transition-colors hover:border-gold/50 hover:text-gold";

  return (
    <div data-testid={testId} className="mt-5 border-t border-white/10 pt-5">
      <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-zinc-500">Share this album</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {canNativeShare && (
          <button data-testid={`${testId}-native`} onClick={nativeShare} className={buttonClass}>
            <Share2 className="h-3.5 w-3.5" /> Share
          </button>
        )}
        {channels.map((channel) => (
          <a key={channel.key} data-testid={`${testId}-${channel.key}`} href={channel.href} target="_blank" rel="noreferrer" className={buttonClass}>
            {channel.label}
          </a>
        ))}
        <button data-testid={`${testId}-copy`} onClick={copyLink} className={buttonClass}>
          {copied ? <Check className="h-3.5 w-3.5" /> : <Link2 className="h-3.5 w-3.5" />}
          {copied ? "Copied" : "Copy link"}
        </button>
      </div>
    </div>
  );
}
